import * as types from './mutation-types'
export default {
    [types.SET_FORM_TEMPLATES](state, data) {
        state.formTemplates = data
    },
    [types.SET_VIEW_USER_GUIDE](state, data) {
        state.viewUserGuide = data.id
    },
    [types.SET_TOTAL_FORM_TEMPLATES](state, totalFormTemplates) {
        state.totalFormTemplates = totalFormTemplates
    },

    [types.ADD_FORM_TEMPLATE](state, data) {
        state.formTemplates.push(data)
    },
    [types.UPDATE_FORM_TEMPLATE](state, data) {
        let updateFormTemplate = state.formTemplates.findIndex(userGuide => userGuide.id === data.id)
        Object.assign(state.formTemplates[updateFormTemplate], { ...data })
    },
    [types.DELETE_FORM_TEMPLATE](state, id) {
        let formTemplates = state.formTemplates.findIndex(user_guide => user_guide.id === id)
        state.formTemplates.splice(formTemplate, 1)
    },
    [types.DELETE_MULTIPLE_FORM_TEMPLATES](state, selectedFormTemplates) {
      selectedFormTemplates.forEach((item) => {
            let index = state.formTemplates.findIndex(_formTemplate => _formTemplate.id === _formTemplate.id)
            state.formTemplates.splice(index, 1)
        })
        state.selectedFormTemplates = []
    },
    [types.SET_SELECTED_FORM_TEMPLATES](state, data) {
        state.selectedFormTemplates = data
    },

    [types.SET_SELECT_ALL_STATE](state, data) {
        state.selectAllField = data
    },
}
